import PatientLatestChannelView from "issara-sdk/apis/PatientLatestChannelView_core";
import PatientLatestSpecialRequestView from "issara-sdk/apis/PatientLatestSpecialRequestView_core";
import { apiErrorTextOf, errorTextOf } from "../errorTextV4";
import type { TeamMessageRecord } from "../../registration/registrationModelV4";

type Context = { apiToken?: unknown; extra?: { division?: number; device?: number } };
export type PatientTeamMessages = {
  latestChannel?: TeamMessageRecord;
  specialRequests?: TeamMessageRecord;
  errors: string[];
};

/** SDK tuple: [data, errorBody, axiosResult]; the third slot is also truthy on success. */
const loadRecord = async (get: () => Promise<any>, label: string) => {
  try {
    const tuple = await get();
    const error = apiErrorTextOf(tuple, { requireData: true });
    if (error) return { error: `${label}: ${error}` };
    if (!Array.isArray(tuple[0]?.items)) {
      return { error: `${label}: ข้อมูลจากระบบมีรูปแบบไม่ถูกต้อง` };
    }
    return { record: tuple[0] as TeamMessageRecord };
  } catch (error) {
    return { error: `${label}: ${errorTextOf(error) || "โหลดไม่สำเร็จ"}` };
  }
};

/** Patient-scoped history: each request can fail without discarding the other result. */
export const loadPatientTeamMessages = async (
  patientId: number, context: Context,
): Promise<PatientTeamMessages> => {
  const [channel, requests] = await Promise.all([
    loadRecord(() => PatientLatestChannelView.get({ pk: patientId, ...context }), "ช่องทางที่รู้จักคลินิก"),
    loadRecord(() => PatientLatestSpecialRequestView.get({ pk: patientId, ...context }), "Request พิเศษ"),
  ]);
  return {
    latestChannel: channel.record,
    specialRequests: requests.record,
    errors: [channel.error, requests.error].filter((error): error is string => !!error),
  };
};
